module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Buat Kontra\n        ")]), _vm._v(" "), _c('Radio-group', {
    attrs: {
      "slot": "extra",
      "type": "button",
      "size": "small"
    },
    slot: "extra",
    model: {
      value: (_vm.showBy),
      callback: function($$v) {
        _vm.showBy = $$v
      },
      expression: "showBy"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "All"
    }
  }), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "Per Marking"
    }
  })], 1), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Tgl. Invoice",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.invoiceDate),
      callback: function($$v) {
        _vm.invoiceDate = $$v
      },
      expression: "invoiceDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "daterange",
      "split-panels": "",
      "placeholder": "Tgl. Bongkar"
    },
    model: {
      value: (_vm.dateFromTo),
      callback: function($$v) {
        _vm.dateFromTo = $$v
      },
      expression: "dateFromTo"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "Dept. Item"
    },
    on: {
      "on-change": _vm.onSelectDepartementChange
    },
    model: {
      value: (_vm.selectDepartement),
      callback: function($$v) {
        _vm.selectDepartement = $$v
      },
      expression: "selectDepartement"
    }
  }, _vm._l((_vm.departements), function(dept, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": dept.id
      }
    }, [_vm._v("\n                        " + _vm._s(dept.deptName) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [(_vm.searchSelectSubbranch == 'JKT') ? _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                        " + _vm._s(subbranch.subbranchname) + "\n                    ")])
  }), 1) : _c('Select', {
    attrs: {
      "disabled": "",
      "placeholder": "Branchcode"
    },
    on: {
      "on-change": _vm.setMarkingCode
    },
    model: {
      value: (_vm.searchSelectSubbranch),
      callback: function($$v) {
        _vm.searchSelectSubbranch = $$v
      },
      expression: "searchSelectSubbranch"
    }
  }, _vm._l((_vm.subbranchs), function(subbranch, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": subbranch.subbranchcode
      }
    }, [_vm._v("\n                        " + _vm._s(subbranch.subbranchname) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBy == 'Per Marking'),
      expression: "showBy == 'Per Marking'"
    }],
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchButton()),
      expression: "showSearchButton()"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingGetReadyKontra,
      "icon": "ios-search-strong"
    },
    on: {
      "click": _vm.getReadyKontra
    }
  }, [(!_vm.loadingGetReadyKontra) ? _c('span', [_vm._v("Cari")]) : _c('span', [_vm._v("Wait.")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.invoicesToShow.length > 0) ? _c('div', [_c('Table', {
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.invoicesToShow,
      "no-data-text": ""
    },
    on: {
      "on-selection-change": _vm.onSelectionChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingGetReadyKontra && _vm.invoicesChecked.length > 0),
      expression: "!loadingGetReadyKontra && invoicesChecked.length > 0"
    }],
    staticClass: "footer"
  }, [_c('h3', [_vm._v(_vm._s(_vm.invoicesChecked.length) + " invoice Selected\n        "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingPost,
      "icon": "checkmark-round",
      "size": "small"
    },
    on: {
      "click": _vm.createKontra
    }
  }, [(!_vm.loadingPost) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("Wait.....")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f49b056","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kontra/KontraCreate.vue
// module id = 1804
// module chunks = 1